export default __webpack_public_path__ + "static/media/Pregnancy_exclusion_tool.70aa04ce.pdf";